import { useState, useCallback } from 'react';
import API from 'api/api';
import { useFirebaseAuth } from 'domains/auth/hooks/useFirebaseAuth';

export default function useAddTrailer() {
  const { uid } = useFirebaseAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const addTrailer = useCallback(
    async (item) => {
      if (!uid) {
        setError(new Error('User not authenticated.'));
        return;
      }

      setLoading(true);
      setError(null);
      setSuccess(false);

      try {
        // Flatten licensePlate to ensure DTO gets a string
        const payload = {
          licensePlate:
            typeof item.licensePlate === 'object'
              ? item.licensePlate.licensePlate
              : item.licensePlate || '',
          trailerCapacity: item.trailerCapacity ?? item.capacity ?? null,
          cmrInvoiceUploaded: Boolean(
            item.cmrInvoiceUploaded ?? item.hasCmrInvoice,
          ),
        };
        
        await API.post(`/users/${uid}/trailer`, payload);
        setSuccess(true);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [uid]
  );

  return { addTrailer, loading, error, success };
}
